/**
 * Set values to null to use the value given from the Launch Darkly
 *   server, if flag is not defined there, it'll give false
 * Set values to false to leave turned off for local dev
 * Set values to true to turn on the feature for local dev
 *
 * @type {{ [name: string]: string | boolean | null }}
 */
export const features = {
  'page-template': null,
  'states-editor': true,
  'subtitle-generator': false,
  'screen-capture-tool': null,
  'vh-ai-generator': true,
  'show-avatar-environment-previews': true,
  'show-in-dev-avatars-environments': true,
  'vh-exam-mode': null,
  'vh-deepgram-elevenlabs-voices': true,
  'preview-features-mode': null,
  'vh-unity-build-path': 'dev',
  'vh-biography-combined': true,
  'vh-freeform-legacy-v2': true,
  'vh-clothing': true,
  'elevenlabs-streaming': true,
  'image-simulation-support': true,
  'no-endpointing-deepgram': true,
  'record-and-send-microphone-option': true,
  'core-scorm-download': true,
  'infobox-types': true,
  'core-new-analytics-overview': true,
  'core-stabilise-feedback-forms': false,
  'virtual-coach': true,
  'show-evaluation-analytics': true,
  'show-selectable-user-language': true,
  'use-deepgram-sdk': true,
  'medical-vh-3': true,
};

/**
 *
 * @param {string} featureName
 */
export const getDevFeature = (featureName) => {
  return features[featureName];
};

export default getDevFeature;
